import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  locations: []
};

const locationsSlice = createSlice({
  name: 'locations',
  initialState,
  reducers: {
    // General loading state for any request
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    // General failure state for any request
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    // Fetch locations success
    fetchLocationsSuccess: (state, action) => {
      state.locations = action.payload;
      state.isLoading = false;
    },
    // Add new location success
    addLocationSuccess: (state, action) => {
      state.locations.push(action.payload);
      state.isLoading = false;
    },
    // Update location success
    updateLocationSuccess: (state, action) => {
      const index = state.locations.findIndex(
        location => location.id === action.payload.id
      );
      if (index >= 0) {
        state.locations[index] = action.payload;
      }
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchLocationsSuccess,
  addLocationSuccess,
  updateLocationSuccess
} = locationsSlice.actions;

export default locationsSlice.reducer;
